const TOKEN_KEY = 'ht_session_token'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function isAuthenticated() {
  return Boolean(getToken())
}

/**
 * POST /api/auth — returns the session token on success.
 * Throws an Error on bad password or network failure.
 */
export async function login(password) {
  const res = await fetch('/api/auth', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  })

  const data = await res.json()

  if (!res.ok) {
    throw new Error(data.error ?? 'Login failed')
  }

  setToken(data.token)
  return data.token
}
